module.exports = __webpack_public_path__ + "static/img/s6.6ab8e7b0.png";